<template>
    <div>
        <div class="font-size-h2 mb-2">
            {{ __('general.settings_basic') }}
        </div>
        <FormGroupNew :label="__('general.layout')"
                      :description="__('offers.widget.layout_description')"
                      required>
            <WidgetTypeSelect v-model="settings.type"/>
        </FormGroupNew>
        <FormGroupNew :label="__('general.columns')"
                      :description="__('offers.widget.columns_description')"
                      required>
            <input type="number" class="form-control" v-model="settings.columns">
        </FormGroupNew>
        <FormGroupNew :label="__('general.offsets') + ' (px)'"
                      :description="__('offers.widget.offset_description')"
                      required>
            <input type="number" class="form-control" v-model="settings.gutter">
        </FormGroupNew>
        <FormGroupNew :label="__('general.border')"
                      :description="__('offers.widget.border_description')"
                      required>
            <Checkbox v-model="settings.border">
                {{ __('general.border') }}
            </Checkbox>
        </FormGroupNew>
        <FormGroupNew :label="__('actions.open_in_new_tab')"
                      :description="__('offers.widget.open_in_new_tab_description')"
                      required>
            <Checkbox v-model="settings.new_tab">
                {{ __('actions.open_in_new_tab') }}
            </Checkbox>
        </FormGroupNew>
        <FormGroupNew :label="__('actions.show_background')"
                      :description="__('offers.widget.background_description')"
                      required>
            <Checkbox v-model="settings.show_bg">
                {{ __('actions.show_background') }}
            </Checkbox>
        </FormGroupNew>
        <FormGroupNew :label="__('general.primary_color')"
                      :description="__('offers.widget.primary_color_description')"
                      required
        >
            <ColorPicker v-model="settings.color"/>
        </FormGroupNew>

        <div v-if="settings.type === 'slider'">
            <div class="font-size-h2 mb-2">
                {{ __('offers.widget.slider_configuration') }}
            </div>
            <FormGroupNew :label="__('offers.widget.autoplay')"
                          :description="__('offers.widget.autoplay_description')"
                          required
            >
                <Checkbox v-model="settings.autoplay">
                    {{ __('offers.widget.autoplay') }}
                </Checkbox>
            </FormGroupNew>
            <FormGroupNew :label="__('offers.widget.slider_interval')"
                          :description="__('offers.widget.slider_interval_description')"
                          required
            >
                <input type="number"
                       class="form-control"
                       v-model="settings.autoplayDelay"
                       :disabled="!settings.autoplay">
            </FormGroupNew>
        </div>
    </div>
</template>

<script>
import ColorPicker from "@components/ColorPicker.vue";
import ToggleModel from "@components/ToggleModel.vue";
import WidgetTypeSelect from "@components/SelectedOffers/Embed/WidgetTypeSelect.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, FormGroupNew, WidgetTypeSelect, ToggleModel, ColorPicker},

    props: {
        value: Object
    },

    data() {
        return {
            settings: this.value,
        }
    },

    watch: {
        settings: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
